module.exports = __webpack_public_path__ + "static/media/md-anderson-uth-no-name.9650033b.svg";